<template>
    <div>
        <mu-avatar icon="list"></mu-avatar>
        <label>列表</label>
    </div>
</template>
<script>
export default {
    name: 'list'
}
</script>



// WEBPACK FOOTER //
// list.vue?3abb1985